
import http from '@/components/services/http-common';
import moment from 'moment/moment';
import EmployeeDialog from '@/components/Crud/Prompt/EmployeeDialog'

export default {
    
    components: {
        'employee-dialog': EmployeeDialog,

    },
    props:["value", "item", "employee"],
    watch:{
        employee(val) {
            console.log("has employee");
        },
        value: {
            handler(val){
                if(val)
                {
                    if(this.isEdit)
                        this.fetch();
                }
                else{
                    this.close();
                }
            }
        },

    },
    computed: {
        dialog: {
            get: function () {
                return this.value;
            },
            set: function (val){
                this.$emit("input", val)
            }
        },
        isEdit() {
            return !!this.item;
        }
    },
    data() {
        return {
            ROOT_URL: "quitRequests/",

            isValid: true,
            fetchData: false,
            isResending: false,
            employeeDialog: false,
            employeeDialog2: false,
            viewImageDialog: false,
            currentImageUrl: '',
            form: {
                "id": null,
                "code": "",
                "name": "",
                "acceptBy1": "",
                "acceptBy2": "",
                "acceptBy3": null,
                "acceptBy1Name": null,
                "acceptBy2Name": "",
                "acceptBy3Name": null,
                "status": 0,
                "quitDate": "",
                "sendDate": "",
                "l1Accept": 0,
                "l2Accept": 0,
                "hrAccept": 0,
                "quitReason": "",
                "note": null,
                "quitTypeCode": "",
                "quitTypeName": ""
            },
            defaultForm:{
                quitDate: null,
                quitReason:"",
                note:""
            },
            quitReasons: [
                "Khác",
            ]
        }
    },
    methods: {
        viewImage(url) {
            this.currentImageUrl = url;
            this.viewImageDialog = true;
        },
        fetch(employee = false){
            this.fetchData =true;
            return http.get(this.ROOT_URL+"manager/"+this.item.code).then(res => {
                this.form = {...res.data.data};
                this.fetchData =false;
            })
        },
        saveData() {
            this.$refs.form.validate();
            if(this.isValid)
            {
                if(!this.isEdit){
                    return http.post(this.ROOT_URL, this.form).then(res =>{
                        this.$emit("fetch");
                        this.dialog = false;
                    })
                }else {
                    return http.put(this.ROOT_URL+ this.item.code, this.form).then(res =>{
                        this.$emit("fetch");
                        this.dialog = false;
                    })
                }
            }
        },
        reset() {
            return http.get(this.ROOT_URL+"hr/reset/"+this.item.code).then(() => {
                this.$emit("fetch");
                this.dialog = false;
            })
        },
        
        resendNotification() {
            this.isResending = true;
            return http.get(this.ROOT_URL+"hr/resend-notification/"+this.item.code).then(() => {
                if (this.$toast) {
                    this.$toast.success("Đã gửi lại thông báo cho nhân viên");
                } else {
                    console.log("Đã gửi lại thông báo cho nhân viên");
                }
            }).catch(err => {
                if (this.$toast) {
                    this.$toast.error("Gửi lại thông báo thất bại");
                } else {
                    console.error("Gửi lại thông báo thất bại", err);
                }
            }).finally(() => {
                this.isResending = false;
            });
        },
        
        deny() {
            return http.get(this.ROOT_URL+"hr/deny/"+this.item.code, {
                params: {
                    note: this.form.note
                }
            }).then(() => {
                this.$emit("fetch");
                this.dialog = false;
            })
        },
        setManager(managerType, e ) {
            if (!e || (Array.isArray(e) && e.length === 0)) {
                return;
            }
            var manCode = Array.isArray(e) ? e[0].code : e.code;
            if (!manCode) return;

            let url = ""
            if(managerType == 1){
                url = this.ROOT_URL+"hr/change-manager-1/" + this.item.code
            }
            if(managerType == 2){
                url = this.ROOT_URL+"hr/change-manager-2/" + this.item.code
            }
            
            return http.put(url, {}, {
                params: {
                    managerCode: manCode
                }
            }).then(r => {
                this.fetch()
                this.employeeDialog = false
                this.employeeDialog2 = false
                this.search = ""
            })
        },
        
        confirm() {
            return http.get(this.ROOT_URL+"hr/accept/"+this.item.code).then(() => {
                this.$emit("fetch");
                this.dialog = false;
            })
        },

        confirmManager1() {
            return http.get(this.ROOT_URL+"manager1/accept/"+this.item.code).then(() => {
                this.$emit("fetch");
                this.dialog = false;
            })
        },
        
        confirmManager2() {
            return http.get(this.ROOT_URL+"manager2/accept/"+this.item.code).then(() => {
                this.$emit("fetch");
                this.dialog = false;
            })
        },

        close(){
            this.form = Object.assign({}, this.defaultForm);
            this.$refs.form.resetValidation();
            this.fetchData=false;
        }
    },
    created() {
    }
}